import React from "react";

function Loader({ text }) {
  return (
    <>
      <div
        className="mainLoader"
      >
        <img className="loaderimg" src="/loader.svg" alt="img" />
        <h2 className="loaderhead">
          {text?.heading}<span className="dot-animation"></span>
        </h2>
        <p className="loaderpara">{text?.paragraph}</p>
      </div>
    </>
  );
}
export default Loader;
